module.exports = __webpack_public_path__ + "img/icon_location.535bf920.png";